/**
 * Release note ATUAL exibido no popup do Dashboard.
 *
 * Como funciona:
 *  - `starts_at` e `expires_at` (ISO local, sem timezone) definem a janela
 *    de exibição. Fora dessa janela, o popup NÃO aparece.
 *  - `id` é usado no sessionStorage — mostra 1× por sessão de browser dentro
 *    da janela. Refresh na mesma sessão NÃO reabre; fechar/reabrir o browser
 *    dispara nova exibição.
 *  - Pra publicar uma NOVA release: edite este arquivo (id/date/version/
 *    sections/starts/expires) e faça deploy. Não precisa mexer no backend.
 *
 * Estrutura das sections: cada uma tem `key` (usado pra pegar o ícone em
 * `ReleaseNotesModal`), `title` (label maiúsculo) e `items` (array de bullets).
 * Item pode ser:
 *   - string simples (retrocompat), OU
 *   - { title, desc } — título negrito + descrição (respeita quebras de linha).
 *
 * Ícones suportados (via `key`): "cardapio", "chatbot", "sistema", "impressao",
 * "financeiro", "pedidos", "agenda". Fallback = Sparkles.
 */
export const currentRelease = {
  id: "2026-11-02-comandas-fidelidade-balanca-visao-geral",
  version: "v1.5.925",
  date: "02/11/2026",
  title: "📢 Novidades de novembro",

  // Cobre a branch novembro-2026 (23/10 a 02/11, v1.5.924 → v1.5.925). Janela
  // de 5 dias: reaparece a cada nova sessão de navegador dentro dela.
  starts_at: "2026-11-02T00:00:00",
  expires_at: "2026-11-06T23:59:59",

  sections: [
    {
      key: "cardapio",
      title: "🚀 Novidades",
      items: [
        {
          title: "Comandas 🧾",
          desc: "A conta do cliente sem mesa: abra pelo número da comanda, lance os itens, transfira ou junte comandas e feche no caixa — com cashback, cartão fidelidade e nota fiscal, como a mesa. Vem desligado.\n\n📍 Configurações → Sistema → Preferências → Módulos da loja → ligue Comandas. O botão aparece no cabeçalho, ao lado de Mesas e Balcão",
        },
        {
          title: "Cartão Fidelidade 👑",
          desc: "Carimbo a cada compra e prêmio automático no 10º, com cupom reservado para aquele cliente. O cartão aparece animado no cardápio, no Totem e no Balcão, e a foto dele vai pelo WhatsApp.\n\n📍 Impulsione suas Vendas → Fidelize seu cliente → Cartão Fidelidade",
        },
        {
          title: "Balança ⚖️",
          desc: "Pese direto no Balcão, nas Comandas, nas Mesas e no Delivery: produto por quilo, pesagem rápida e o peso do recipiente descontado. Precisa do Núcleo Desktop 1.0.724, que atualiza sozinho.\n\n📍 Configurações → Sistema → aba Integração → Balança (no computador onde ela está ligada)",
        },
        {
          title: "Visão Geral nova 📊",
          desc: "Hoje comparado com ontem e com o ano passado até a mesma hora, pizza por sabor, clientes novos e que voltaram, mapa de calor da semana e os cartões do dia.\n\n📍 Visão Geral (a primeira tela)",
        },
        {
          title: "Relatório de Tempo ⏱️",
          desc: "O movimento hora a hora de mesas, comandas, delivery, retirada e iFood, com setas contra o período anterior e filtro por dia da semana.\n\n📍 Relatórios → Relatório de Tempo",
        },
        {
          title: "Fotos e vídeo do produto 📸",
          desc: "Até 3 fotos ou um vídeo de 15 s por produto, e um banner em vídeo no topo do cardápio.\n\n📍 Cardápio → Produtos",
        },
        {
          title: "Totem e Mesa QR com cardápio próprio 🖥️",
          desc: "Cada canal tem seus produtos, preços, cupons e formas de pagamento. O que já valia no Balcão e nas Mesas foi copiado para eles — nada muda sem você mexer.",
        },
        {
          title: "Ofertas por tipo de cliente 🎯",
          desc: "Cupom, cashback e promoção podem valer só para um tipo de cliente (novo, frequente, sumido…). Em cada card de tipo tem o botão Criar oferta.\n\n📍 Pessoas e Fornecedores → Clientes → Criar oferta",
        },
        {
          title: "Avaliação do pedido ⭐",
          desc: "30 minutos depois do pedido, a CLEO convida o cliente a avaliar; no cardápio aparece Avalie seu último pedido. Vale para os 7 módulos.\n\n📍 Impulsione suas Vendas → Campanhas → Avaliação de Pedidos",
        },
        {
          title: "QR Code dos links de divulgação 🔗",
          desc: "Baixe o QR Code de cada link (imagem ou PDF) ou imprima na impressora do caixa.\n\n📍 Impulsione suas Vendas → Links de divulgação",
        },
        {
          title: "Ajuda com vídeos 🎬",
          desc: "Vídeos curtos de cada tela do painel.\n\n📍 Menu lateral → Ajuda",
        },
      ],
    },
    {
      key: "sistema",
      title: "✨ Melhorias",
      items: [
        {
          title: "Clientes 👥",
          desc: "Lista rápida mesmo com milhares de clientes, cadastro novo com endereço por CEP e bairro, faixa e selo do tipo de cliente.\n\n📍 Pessoas e Fornecedores → Clientes",
        },
        {
          title: "Caixa 💵",
          desc: "Tirar dinheiro, Colocar dinheiro e Fechar caixa no topo, fechamento com contagem de notas, diferença aceitável nas Preferências e caixas anteriores em páginas.",
        },
        {
          title: "Horários 🕒",
          desc: "Tela nova com os cards dos dias e a grade da semana; 23:59 é o fim do dia e a virada para 00:00 é contínua.\n\n📍 Configurações → Horários",
        },
        {
          title: "Promoções e Cupons 🏷️",
          desc: "Formulário de promoção novo (De R$ X por R$ Y, % de desconto), cupom com dia, horário e início valendo de verdade e Onde vale por módulo (Balcão, Totem, Mesas, Mesa QR, Comandas).\n\n📍 Impulsione suas Vendas → Promoções / Cupons",
        },
        {
          title: "Produtos 🍔",
          desc: "Filtros novos, categoria com busca, novo produto com categoria obrigatória e preço digitado como na maquininha, indicadores de ficha técnica e dados fiscais, e excluir de vez quando o produto nunca vendeu.",
        },
        {
          title: "Relatórios 📈",
          desc: "Cabeçalho igual em todos, somas sem perder centavos, Relatório de Estoque com a ficha por tamanho da pizza e separador de milhar no resumo do dia.",
        },
        {
          title: "No celular 📱",
          desc: "Balcão, Fluxo de Caixa, Bairros, DRE, Disparos, Estoque, Sistema, Formas de Pagamento e Campanhas usáveis no celular, e as telas de operação sem o menu por cima.",
        },
        {
          title: "Mais fácil no dia a dia 🎨",
          desc: "As telas carregam com cards cinza em vez da rodinha, R$ sempre com vírgula, tema claro ou escuro por usuário, tutorial uma vez por usuário e o Acompanhe seu pedido repaginado para o cliente.",
        },
      ],
    },
    {
      key: "pedidos",
      title: "🔧 Correções",
      items: [
        "Balcão: dois pacotes com o mesmo peso (mesma etiqueta) agora entram como dois itens",
        "Balcão: cupom só de Balcão não some mais do pedido",
        "Cardápio: o botão Aplicar do cupom voltou a funcionar",
        "Caixa: concluir o mesmo pedido duas vezes não lança a venda duas vezes",
        "Delivery: retirada marcada Já pago não cobra de novo, e o troco da divisão em dinheiro fica gravado",
        "Promoção de pizza por tamanho não aceita mais preço acima do normal nem 100% de desconto",
        "Despesas: mudar a natureza da classificação passa a valer no DRE",
        "WhatsApp: Saiu para entrega volta a ser enviado com entregador próprio",
        "Impressão: pedido reenviado na reconexão sai só no computador certo",
        "Cardápio: categoria oculta some de verdade e a busca não marca categoria como esgotada",
        "Cartão fidelidade: quem completa o cartão recebe um aviso só",
      ],
    },
    {
      key: "atencao",
      title: "⚠️ Fique atento",
      items: [
        {
          title: "Seus clientes entram de novo no cardápio",
          desc: "Por segurança, quem estava logado no cardápio vai entrar de novo uma vez, com o telefone. Depois disso fica 30 dias sem pedir.",
        },
        {
          title: "Aba PIX só para dono e administrador",
          desc: "Funcionário e observador não alteram mais a credencial do PIX.",
        },
        {
          title: "Comandas vem desligado e a balança precisa do Desktop novo",
          desc: "O Núcleo Desktop atualiza sozinho para a 1.0.724; no antigo, a tela da balança avisa para atualizar.",
        },
      ],
    },
  ],

  coming_soon: [
    {
      title: "Disparos por WhatsApp 💬",
      desc: "Campanhas pelo WhatsApp oficial, no mesmo painel do SMS.",
    },
    {
      title: "Mais marketplaces 🛵",
      desc: "aiqfome, 99Food e Keeta no mesmo lugar que o iFood.",
    },
  ],
};
